import { Component, Input } from '@angular/core';
import { Color } from '../../../constants/color.constants';
import { Icons } from '../../../constants/icons.constants';

export interface TimelineDetailItem {
    title: string;
    data: string;
    complete: boolean;
}

export interface TimelineItem {
    title: string;
    date: string;
    complete: boolean;
    details?: TimelineDetailItem[];
}

@Component({
    selector: 'lsq-detailed-timeline',
    templateUrl: './lsq-detailed-timeline.component.html',
    styleUrls: ['./lsq-detailed-timeline.component.scss']
})
export class LsqDetailedTimelineComponent {
    @Input() public timelineItems: TimelineItem[];
    public icons = Icons;
    public color = Color;
}
